var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"soupe-ui-tag tag",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default"),(_vm.selected)?_c('button',{staticClass:"delete is-small"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }